<template>
  <div>
    <div class="center">
      <div class="logo">
        <div class="title">技术成就未来</div>
        <div class="eng">Technological Advancements Forge the Future</div>
        <div class="logo-left"></div>
        <div class="logo-right"></div>
      </div>
      <div class="but">
        <el-button class="contact-btn" @click="kf()">
          <el-icon class="icon-left">
            <Document />
          </el-icon>
          资质、发票、投诉
          <el-icon class="icon-right">
            <ArrowRight />
          </el-icon>
          联系客服
        </el-button>
        <el-dropdown trigger="click" @command="handleDropdownCommand">
          <el-button type="success" size="small" class="contact-btn">
            在线经济评价
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="create">新建项目</el-dropdown-item>
            <el-dropdown-item command="open">打开已有项目</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <input
          type="file"
          ref="fileInput"
          accept=".json"
          style="display: none"
          @change="handleFileSelect"
        />
      </div>
    </div>

    <div class="fenlei">
      <div class="fenlei-content" v-for="(item, index) in newlist" :key="index">
        <div class="fenlei-title">{{ item.name }}</div>
        <div class="fenlei-text" v-for="(res, i) in item.list" :key="i">
          <div class="fenlei-text-list" @click="GZlqd(res)">
            {{ res.projectType }}
          </div>
        </div>
      </div>
    </div>
    <div class="di"></div>
    <div class="beian">
      <a href="https://beian.miit.gov.cn/" target="_blank">备案号：</a>
      <a href="https://beian.miit.gov.cn/" target="_blank"
        >蒙ICP备19003815号-7</a
      >
    </div>
    <div class="Jindex" v-if="showJindex">
      <Jindex @close="handleJindexClose" />
    </div>
  </div>
</template>

<script>
import { Setitem, Getitem } from "../../utils/item.js";
import { manage } from "../../utils/request.js";
import Jindex from "./jjpj/Jindex.vue";
import jjpjTemplate from "../../utils/jjpj.js";

export default {
  components: {
    Jindex,
  },
  data() {
    return {
      newlist: this.$store.state.prjectmenu || [],
      managearr: [],
      managelist: [],
      showJindex: false,
      isNewProject: false,
      hasSavedBefore: false,
    };
  },
  methods: {
    GZlqd(res) {
      this.$router.push("/zlqd");
      setTimeout(() => {
        this.$store.commit("setporjecttype", res);
      }, 100);
    },
    async kf() {
      await this.llxm();
    },
    llxm() {
      if (!this.managelist || !this.managelist.length) {
        this.$toast.error("网络错误，没有读取到管理员");
        this.managearr = [];
        return;
      }
      this.managearr = [];
      const checkOnlineStatus = async () => {
        try {
          for (const res of this.managelist) {
            const toUser = `manage_${res.id}`;

            // 提交状态更新
            this.$store.commit("setSwindow", toUser);

            // 等待状态更新完成
            await new Promise((resolve) => setTimeout(resolve, 300));
            await this.$nextTick();

            // 获取最新的在线状态
            const online = this.$store.state.otherline;
            const username = res.username || res.id;
            // console.log(`管理员 ${username} 在线状态: ${online}`);

            // 检测到在线管理员，添加到数组后立即中止循环
            if (online === "在线") {
              this.managearr.push(res);

              break; // 终止循环，不再检查后续管理员
            }
          }
          this.chatmanage();
        } catch (error) {
          // console.error('检查在线状态时出错:', error);
          this.managearr = [];
        }
      };
      checkOnlineStatus();
    },
    chatmanage() {
      let data;
      if (this.managearr.length == 0) {
        this.$toast.error("没有在线管理员，您可以给主管理员留言");
        data = {
          toid: this.managelist[0].id,
          toname: `客服${this.managelist[0].id}`,
          myname: Getitem("name"),
          myid: Getitem("userid"),
          toclass: "manage",
        };
      } else {
        data = {
          toid: this.managearr[0].id,
          toname: `客服${this.managearr[0].id}`,
          myname: Getitem("name"),
          myid: Getitem("userid"),
          toclass: "manage",
        };
      }
      this.$store.commit("setgochat", data);
    },
    compareJsonStructure(obj1, obj2) {
      if (typeof obj1 !== "object" || obj1 === null) {
        return false;
      }

      // 使用特殊键来识别本系统制作的文件
      // 检查是否包含系统特定标识符
      if (!obj1.hasOwnProperty("jindexname")) {
        return false;
      }

      // 只检查核心顶级键是否存在，允许扩展
      const coreKeys = [
        "基础数据",
        "总投资估算",
        "资金筹措及分年投资计划",
        "成本费用",
        "营业收入税金及利润",
        "盈利能力分析",
        "不确定性分析",
        "流动资金估算",
      ];

      // 检查所有核心键是否存在
      for (const key of coreKeys) {
        if (!(key in obj1)) {
          return false;
        }
      }

      return true;
    },
    handleDropdownCommand(command) {
      if (command === "create") {
        this.createNewProject();
      } else if (command === "open") {
        this.openExistingProject();
      }
    },
    createNewProject() {
      this.$store.commit(
        "setProjectData",
        JSON.parse(JSON.stringify(jjpjTemplate))
      );
      this.$store.commit("setSaveFileHandle", null);
      this.$store.commit("setIsProjectSaved", false);

      //   let s = this.$store.state.projectData;
      let plan =
        jjpjTemplate["资金筹措及分年投资计划"]?.["分年投资计划"]?.["总投资"]
          .amount || 0;
      this.$store.commit("setplanamount", plan);

      this.isNewProject = true;
      this.hasSavedBefore = false;
      this.showJindex = true;
    },
    openExistingProject() {
      if (window.showOpenFilePicker) {
        window
          .showOpenFilePicker({
            types: [
              {
                accept: {
                  "application/json": [".json"],
                },
              },
            ],
            excludeAcceptAllOption: true,
            multiple: false,
          })
          .then((fileHandles) => {
            const fileHandle = fileHandles[0];
            this.$store.commit("setSaveFileHandle", fileHandle);
            return fileHandle.getFile().then((file) => {
              return file.text();
            });
          })
          .then((fileContent) => {
            try {
              const cleanedContent = fileContent.replace(/^\uFEFF/, "");
              const jsonData = JSON.parse(cleanedContent);

              if (this.compareJsonStructure(jsonData, jjpjTemplate)) {
                this.$store.commit("setProjectData", jsonData);
                this.$store.commit("setIsProjectSaved", true);
                this.isNewProject = false;
                this.hasSavedBefore = true;
                this.showJindex = true;
                this.$toast.success("项目文件加载成功");
              } else {
                this.$toast.error("项目文件错误");
              }
            } catch (error) {
              console.error("JSON文件解析错误:", error);
              this.$toast.error("请选择有效的JSON文件");
            }
          })
          .catch((err) => {
            if (err.name !== "AbortError") {
              console.error("打开文件失败:", err);
              this.$toast.error("打开文件失败：" + err.message);
            }
          });
      } else {
        this.$refs.fileInput.click();
      }
    },
    handleFileSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const content = e.target.result.replace(/^\uFEFF/, "");
          const jsonData = JSON.parse(content);

          if (this.compareJsonStructure(jsonData, jjpjTemplate)) {
            this.$store.commit("setProjectData", jsonData);
            this.$store.commit("setIsProjectSaved", true);
            this.$store.commit("setSaveFileHandle", {
              isTraditionalFile: true,
              filename: file.name,
            });
            this.isNewProject = false;
            this.hasSavedBefore = true;
            this.showJindex = true;
            this.$toast.success("项目文件加载成功");
          } else {
            this.$toast.error("项目文件错误");
          }
        } catch (error) {
          console.error("JSON文件解析错误:", error);
          this.$toast.error("请选择有效的JSON文件");
        }
      };
      reader.readAsText(file);
      event.target.value = "";
    },
    handleJindexClose() {
      this.showJindex = false;
    },
  },

  watch: {
    "$store.state.prjectmenu": {
      deep: true,
      handler(newVal) {
        this.newlist = newVal;
      },
      immediate: true,
    },
  },

  async created() {
    let res = await manage();
    if (res.code === 200) {
      this.managelist = res.list;
    } else {
      this.managelist = [];
    }
  },
};
</script>

<style lang="less" scoped>
.center {
  width: 50vw;
  height: 50vh;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;

  .but {
    margin: auto;
    padding-top: 2vh;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 25px;
  }

  // 新的联系客服按钮样式
  .contact-btn {
    background: linear-gradient(135deg, #409eff 0%, #6bb8ff 100%);
    color: #fff;
    border: none;
    padding: 12px 30px;
    font-size: 16px;
    border-radius: 30px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 12px;
    box-shadow: 0 4px 15px rgba(64, 158, 255, 0.3);

    &:hover {
      background: linear-gradient(135deg, #3a8ee6 0%, #5aa7e6 100%);
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(64, 158, 255, 0.4);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 10px rgba(64, 158, 255, 0.3);
    }

    .icon-left,
    .icon-right {
      font-size: 18px;
    }

    .icon-right {
      transition: transform 0.3s ease;
    }

    &:hover .icon-right {
      transform: translateX(3px);
    }
  }

  .logo {
    width: 50vw;
    height: 30vh;
    background-color: rgba(0, 0, 0, 40%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: 100;
    position: relative;

    .logo-left {
      position: absolute;
      top: 0;
      left: 0;
      border-top: 2px solid #fff;
      border-left: 2px solid #fff;
      width: 30px;
      height: 30px;
      z-index: 60;
    }

    .logo-right {
      position: absolute;
      bottom: 0;
      right: 0;
      border-right: 2px solid #fff;
      border-bottom: 2px solid #fff;
      width: 30px;
      height: 30px;
      z-index: 60;
    }

    .title {
      padding: 0 0 10px 0;
      width: 100%;
      font-size: 4vw;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #e5e5e5;
    }

    .eng {
      width: 100%;
      font-size: 2vw;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #e5e5e5;
    }
  }
}

.di {
  position: absolute;
  top: 80vh;
  left: 0;
  right: 0;
  bottom: 0;
  height: 20vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
}

.fenlei {
  width: 55vw;
  height: 30vh;
  position: absolute;
  top: 65vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 70;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .fenlei-content {
    width: 9vw;
    height: 30vh;
    background-color: rgba(#e5e5e5, 0.8);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    padding: 7px;
    border-radius: 5px;
    box-shadow: 0 18px 16px rgba(0, 0, 0, 0.6);
    border: 1px solid #a6a6a6;

    .fenlei-title {
      font-size: 18px;
      color: #333;
      padding: 7px 0;
      text-align: center;
      font-weight: bold;
    }

    .fenlei-text {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: start;
      font-size: 13px;
      line-height: 22px;

      .fenlei-text-list {
        text-align: left;
        line-height: 22px;
        padding: 0 5px;
        cursor: pointer;
      }

      .fenlei-text-list:active {
        border-color: #3a8ee6;
      }

      .fenlei-text-list:hover {
        border-color: #c6e2ff;
        color: #409eff;
      }
    }
  }
}

.sp:active {
  border-color: #3a8ee6;
}

.sp:hover {
  border-color: #c6e2ff;
  color: #409eff;
}

.beian {
  position: absolute;
  top: 97vh;
  left: 50%;
  font-size: 15px;
  color: #fff !important;
  transform: translateX(-50%);

  a {
    color: #efefef;
    text-decoration: none;
  }
}

.Jindex {
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: #fff;

  z-index: 900;
}
</style>
